import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
//refactored
import MyPageHeader from 'components/containers/mypage/MyPageHeader'
import MyPageProfile from 'components/containers/mypage/MyPageProfile'
import MyPageProjectAchieve from 'components/containers/mypage/MyPageProjectAchieve'
import MyPageAchievementChart from 'components/containers/mypage/MyPageAchievementChart'
import CompanyInfoFooterView from 'components/presenters/footer/CompanyInfoFooter/CompanyInfoFooterView'

import ManageOptionList from 'components/presenters/mypage/ManageOptionList'
import { useSelector } from 'react-redux'
import server from 'server/serverController2'

import { MyPageInner } from './style'
import { UserInfoActions } from 'store/actionCreators'

//날짜 출력 폼 형태
function getDateType(date) {
  function checkZero(checkString) {
    return checkString.toString().length == 1 ? '0' + checkString : checkString
  }
  let temp = `${checkZero(date.getFullYear())}-${checkZero(date.getMonth() + 1)}-${checkZero(
    date.getDate(),
  )}`
  return temp
}

export default function MyPageMainLayout({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  // 유저 정보
  const [user, setUser] = useState({})
  const [userImg, setUserImg] = useState({})
  const [totalUserGroup, setTotalUserGroup] = useState(null)
  const [projectsrate, setProjectsrate] = useState([])
  const [unreadPaybackNum, setUnreadPaybackNum] = useState(null)

  const userCallBack = (jsonData) => {
    try {
      if (jsonData.success !== 1) {
        alert('예기치 못한 오류가 발생하였습니다.')
        return
      }
      const data = jsonData['data']
      const userData = data['user']
      UserInfoActions.updateUserState({
        name: userData.nickname,
        email: userData.email,
        id: userData.no,
        isLogin: true,
        achievement_goal: userData.achievement_goal,
        profile_img: userData.profile_img,
        exp_point: userData.exp_point,
      })
      setUser(jsonData.data.user)
      setUserImg(jsonData.data.user.profile_img)
    } catch (err) {
      console.log('error')
      console.log(err)
    }
  }

  const updateUserRoleCallback = (jsonData) => {
    try {
      if (jsonData['success'] !== 1) {
        return
      }
      const data = jsonData['data']
      let userRole = null
      if (data?.userInfo?.role) {
        userRole = data['userInfo']['role']
      }
      UserInfoActions.updateRole({
        role: userRole,
      })
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
    }
  }

  useEffect(async () => {
    server.getRequestData(`users/${userInfo['id']}`, userCallBack)
    server.getRequestData(`auth`, updateUserRoleCallback)
  }, [])

  const [chartWeekendData, setChartWeekendData] = useState(null)
  const [chartMonthData, setChartMonthData] = useState(null)

  // 모임 리스트 데이터 받기
  const [groupslist, setGroupslist] = useState([])
  const groupsinfoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.')
      return
    }
    setGroupslist(jsonData.data.groups)
  }

  //친구정보
  const [friendNum, setFriendNum] = useState([])
  const infoCallBack = (res) => {
    if (res.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.')
      return
    }
    const jsonData = res.data
    setFriendNum(jsonData.count)
  }

  const tasksRateWeekendCallBack = (res) => {
    let list = []
    res.data.task_rate.map((value) => {
      list.push({
        name: value.date.split('-')[1] + '/' + value.date.split('-')[2],
        uv: value.rate,
      })
    })
    setChartWeekendData(list)
  }

  const tasksRateMonthCallBack = (res) => {
    let list = []
    res.data.task_rate.map((value) => {
      list.push({ name: value.date.split('-')[1], uv: value.rate })
    })
    setChartMonthData(list)
  }

  const getUserGroupTotalCallback = (res) => {
    if (res.success === 1) {
      if (res['data'] && res['data']['count']) {
        setTotalUserGroup(res['data']['count'])
      }
    }
  }

  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
    let month = new Date()
    month.setMonth(month.getMonth() - 6)
    // server.getRequestData(
    // 	`users/${userInfo['id']}/groups`,
    // 	groupsinfoCallBack,
    // );
    server.getRequestData(`friends?get_total=true`, infoCallBack)
    server.getRequestData(`users/projects/rate`, rateCallBack)
    server.getRequestData(
      `tasks/rate?start_date=${getDateType(
        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      )}&end_date=${getDateType(new Date())}`,
      tasksRateWeekendCallBack,
    )
    server.getRequestData(
      `tasks/rate?start_date=${getDateType(month)}&end_date=${getDateType(new Date())}&type=month`,
      tasksRateMonthCallBack,
    )
    // server.getRequestData(
    // 	`users/${userInfo['id']}/groups?get_total=true`,
    // 	getUserGroupTotalCallback,
    // );
    server.getRequestData(`users/commerce/paybacks/unread`, (res) => {
      try {
        if (res.success !== 1) {
          alert('예기치 못한 오류가 발생하였습니다.')
          return
        }
        const jsonData = res.data
        const unreadData = jsonData.unread
        if (unreadData?.unread_num) {
          const unreadNum = unreadData.unread_num
          if (unreadNum > 0) {
            setUnreadPaybackNum(unreadNum)
          }
        }
      } catch (err) {
        console.log(err)
      }
    })
  }, [])

  //프로젝트 달성률

  const rateCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.')
      return
    }
    setProjectsrate(jsonData.data.items)
  }

  return chartWeekendData ? (
    <MyPageInner>
      <MyPageHeader title={'마이페이지'} borderbottom={'solid calc(100vw*(1/375)) #d5d5d5'} />
      <MyPageProfile
        userInfo={userInfo}
        groupslist={groupslist}
        friendNum={friendNum}
        userImg={userImg}
        totalUserGroup={totalUserGroup}
      />
      <ThinDivider />
      <ManageOptionList unreadPaybackNum={unreadPaybackNum} />
      <MyPageProjectAchieve projectsrate={projectsrate} />
      <MyPageAchievementChart chartWeekendData={chartWeekendData} chartMonthData={chartMonthData} />
      <CompanyInfoFooterView />
    </MyPageInner>
  ) : (
    <div></div>
  )
}

const ThinDivider = styled.div`
  width: calc(100vw * (351 / 375));
  height: 1px;
  background-color: #f2f3f6;
  margin: 0 auto;
`
